var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgQuestionSignIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99915 9.99915C9.99915 8.89413 10.8949 7.99832 12 7.99832C13.105 7.99832 14.0008 8.89413 14.0008 9.99915C14.0008 11.1042 13.105 12 12 12",
    stroke: "#DF9608",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5006V12",
    stroke: "#DF9608",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99622 16.0017V7.99833C2.99622 5.23576 5.23572 2.99625 7.9983 2.99625H16.0016C18.7642 2.99625 21.0037 5.23576 21.0037 7.99833V16.0017C21.0037 18.7642 18.7642 21.0037 16.0016 21.0037H7.9983C5.23572 21.0037 2.99622 18.7642 2.99622 16.0017Z",
    stroke: "#DF9608",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9516C11.9723 15.9516 11.9499 15.974 11.9499 16.0017C11.9499 16.0293 11.9723 16.0517 12 16.0517C12.0276 16.0517 12.05 16.0293 12.05 16.0017C12.05 15.974 12.0276 15.9516 12 15.9516",
    stroke: "#DF9608",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionSignIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/QuestionSignIcon.02643e3b.svg";
export { ForwardRef as ReactComponent };